import { Global } from "@emotion/react"

const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: "NSG-medium";
        src: local(""), url("../../fonts/NotoSansGeorgian/NotoSansGeorgian-Medium.ttf") format("opentype");
      }

      @font-face {
        font-family: "NSG-semi-bold";
        src: local(""), url("../../fonts/NotoSansGeorgian/NotoSansGeorgian-SemiBold.ttf") format("opentype");
      }

      @font-face {
        font-family: "NSG-regular";
        src: local("") url("../../fonts/NotoSansGeorgian/NotoSansGeorgian-Regular.ttf") format("opentype");
      }
    `}
  />
)

export default Fonts
